import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { absFile, evDate } from "@/lib/api";
import { themeFor } from "@/lib/themes";
import { EventDecor, Asterisk } from "@/components/Motifs";

export default function Poster({ e, i, className = "", imgH = "h-64 md:h-80" }) {
  const t = themeFor(e.slug);
  const d = evDate(e.date);
  const day = d.toLocaleDateString("en-GB", { day: "2-digit" });
  const mon = d.toLocaleDateString("en-GB", { month: "short" }).toUpperCase();
  return (
    <Link
      to={`/celebrations/${e.slug}`}
      data-testid={`event-card-${e.slug}`}
      className={`poster group relative flex flex-col overflow-hidden p-6 md:p-8 pt-12 ${className}`}
      style={{ background: t.bg, color: t.fg }}
    >
      <EventDecor slug={e.slug} t={t} />
      <div className="relative flex items-start justify-between gap-4">
        <div>
          <div className="kicker" style={{ color: t.accent }}>No. 0{i + 1}</div>
          <div className="font-hand text-lg mt-1 opacity-90">{t.label}</div>
        </div>
        <div className="text-right leading-none border-2 px-3 py-2" style={{ borderColor: t.fg }}>
          <div className="font-display text-3xl md:text-4xl">{day}</div>
          <div className="kicker mt-1">{mon}</div>
        </div>
      </div>
      <div className={`relative mt-6 overflow-hidden ${imgH} ${t.imgClass} ${e.slug === "sangeet" ? "aspect-square h-auto w-3/4 mx-auto" : ""}`}>
        <img src={absFile(e.image_url || t.image)} alt={e.name} loading="lazy" className="poster-img w-full h-full object-cover" />
      </div>
      <h3 className={`relative mt-6 ${e.slug === "reception" ? "text-4xl md:text-5xl" : "text-4xl sm:text-5xl md:text-6xl"} leading-[0.9] break-words ${t.titleClass}`} style={{ color: e.slug === "wedding" ? t.fg : t.accent }}>
        {e.name.replace("Wedding ", "")}
      </h3>
      <p className="relative font-display italic text-lg md:text-xl mt-3 opacity-90">{e.headline || t.headline}</p>
      <div className="relative mt-auto pt-6 flex items-center justify-between gap-4 border-t border-current/20" style={{ borderColor: `${t.fg}33` }}>
        <span className="kicker opacity-80 flex items-center gap-2"><Asterisk size={12} />{e.venue}</span>
        <ArrowRight size={20} className="poster-arrow shrink-0" />
      </div>
    </Link>
  );
}
